import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import DynamicClaimForm from '../../components/claims/DynamicClaimForm';

const SubmitClaim = () => {
  return (
    <DashboardLayout
      maxWidth="5xl"
      padding="default"
      background="silver-mist"
      className="min-h-screen"
    >
      <DynamicClaimForm />
    </DashboardLayout>
  );
};

export default SubmitClaim;
